import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  open: boolean;
  fileName: string;
  /** 保存が可能か（他人のファイルで編集不可の場合は false → 保存ボタン非活性） */
  canSave?: boolean;
  onSave: () => void;
  onDiscard: () => void;
  onCancel: () => void;
};

/**
 * 未保存のタブを閉じる際の3択確認ダイアログ。
 */
const UnsavedCloseDialog: React.FC<Props> = ({
  open,
  fileName,
  canSave = true,
  onSave,
  onDiscard,
  onCancel,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="xs"
      slotProps={{
        paper: {
          elevation: 0,
          sx: { borderRadius: 3, border: 1, borderColor: 'divider' },
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="subtitle1" fontWeight={600}>
          「{fileName}」への変更を保存しますか？
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            保存しない場合、変更は失われます。
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          キャンセル
        </Button>
        <Button
          color="error"
          onClick={onDiscard}
          sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
        >
          保存しない
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={!canSave}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          }}
        >
          保存
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnsavedCloseDialog;
